let baseUrl;
if (typeof navigator !== "undefined" && navigator.product === "ReactNative") {
  baseUrl = "http://localhost";
} else {
  baseUrl = ``;
}

export default {
  api: {
    baseUrl,
    clientId: 2,
    clientSecret: "q0ixQ1qi3KmxiS0VQ89hulQqR8tBtQxuSCyCcyUV"
  },
  facebook: {
    appId: "123456789"
  },
  google: {
    clientId: "123456789"
  },
  login: {
    email: true,
    facebook: false,
    google: false
  }
};



// WEBPACK FOOTER //
// ./src/config/index.js